export default "__VITE_ASSET__BXhoPGVM__"